import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-cmd-config",
  "use": "icon-soc-cmd-config-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-cmd-config\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<rect x=\"160\" y=\"224\" width=\"704\" height=\"576\" rx=\"40\" /><path d=\"M160 224h704v96H160z\" /><path d=\"M288 416l96 64-96 64v-48l48-16-48-16v-48z\" fill=\"#fff\" /><path d=\"M640 640h160v64H640z\" fill=\"#fff\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-cmd-config.svg
// module id = mcwk
// module chunks = 534